import React, { useState, useRequest, useEffect } from "react";
import {
  faChevronDown,
  faChevronUp,
  faExclamationCircle,
  faTrash,
} from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/pro-solid-svg-icons";
import { get, isEmpty, isNull } from "lodash";
import {
  OPTIONS_DATA_MAPPER,
  returnOnlyIfBoolean,
  yesNoOptions,
  toOptionValuesFromMapper,
  LOANS_PAYROLL_FREQUENCY,
  usDateFormat,
  momentDateFormat,
  getInterestRateForFrequency,
  calculateTotalNoOfInstallments,
} from "../../utils";
import payrollFrequency from "../../mocks/payrollFrequency.json";
import AddToolTip from "../AddToolTip";
import { Field } from "formik";
import {
  FieldButtonGroup,
  FieldDropSide,
  FieldInput,
  FieldInputDollar,
  FieldInputDollarBox,
  FieldInputMonthBox,
  FieldInputNumber,
  FieldInputPercentage,
  FieldInputPercentageBox,
  FieldMultiSelectButtonGroup,
} from "../Forms";
import SearchableList from "../SearchableList";
import InputGroup from "react-bootstrap/InputGroup";
import { Link } from "react-router-dom";
import BankDetails from "../BankDetails";
import AddressDetails from "../AddressDetails";
import { faTrashAlt } from "@fortawesome/pro-solid-svg-icons";
import { useDeepEffect, useRouterParams } from "../../abstracts";
import FieldInputYearBox from "../Forms/FieldInputYearBox";
import {
  getEmployeeCensusInformation,
  getEmployeeEligiblePlanLoans,
} from "../../services";

import { getCurrentDateInDDMMYYYY, clearFieldValues } from "../../utils";
import DatePicker from "../DatePicker";
import moment from "moment";

const LoanCard = (props) => {
  const {
    fields,
    setFieldValue,
    handleChange,
    values,
    setValues,
    setSliderOpen4,
    data,
    planData,
    availableBalanceForLoan = 10000,
    getPeriodicPayment,
    frequencyListData,
    payrollSchedule,
    empFreqId,
    repaymentMethodsOptions,
    apiData,
  } = props;

  const interestRate = get(values, "interestRate");
  const vestedBalance = planData?.sourceBalances?.reduce(
    (a, v) =>
      (a = a + v.vestingMultiplier * v.sourceEmployeeMap?.accountBalance),
    0
  );

  useEffect(() => {
    if ((values.tenureYears || values.tenureMonths) && values.requestedAmount) {
      const newPeriodicPayment = getPeriodicPayment(
        values.requestedAmount,
        values.tenureYears,
        values.tenureMonths,
        interestRate,
        values["repaymentFrequency"]
      );
      setFieldValue(fields.periodicPayment, newPeriodicPayment);
    }
  }, [values["repaymentFrequency"]]);
  const handlePeriodicPaymentChange = (value) => {
    //Case 1,6,7
    if (value && values.requestedAmount) {
      const tenure = getTenure(values.requestedAmount, parseFloat(value));
      var years = Math.floor(tenure / 12);
      var months = Math.ceil(tenure % 12);
      if (months == 12) {
        years += 1;
        months = 0;
      }
      setFieldValue(fields.tenureYears, years);
      setFieldValue(fields.tenureMonths, months);
    }
    //Case 3,9
    // if (
    //   value &&
    //   (values.tenureMonths || values.tenureYears) &&
    //   !values.requestedAmount
    // ) {
    //   const loanAmount = getLoanRequestAmount(
    //     value,
    //     values.tenureYears,
    //     values.tenureMonths
    //   );
    //   setFieldValue(fields.requestedAmount, loanAmount);
    // }
  };

  const handleLoanRequestAmountChange = (value) => {
    //Case 2
    if (
      value &&
      !values[fields.periodicPayment] &&
      (values.tenureMonths || values.tenureYears)
    ) {
      const newPeriodicPayment = getPeriodicPayment(
        value,
        values.tenureYears,
        values.tenureMonths,
        interestRate,
        values["repaymentFrequency"]
      );
      setFieldValue(fields.periodicPayment, newPeriodicPayment);
    }

    //Case 8
    if (value && values[fields.periodicPayment]) {
      const tenure = getTenure(value, values[fields.periodicPayment]);
      setFieldValue(fields.tenureMonths, Math.ceil(tenure % 12));
      setFieldValue(fields.tenureYears, Math.floor(tenure / 12));
    }
  };

  const handleTenureChange = (isMonth, value) => {
    const newMonths = isMonth ? parseInt(value) : parseInt(values.tenureMonths);
    const newYears = isMonth ? parseInt(values.tenureYears) : parseInt(value);
    //Case 4,5

    if (value && values.requestedAmount) {
      const newPeriodicPayment = getPeriodicPayment(
        values.requestedAmount,
        newYears,
        newMonths,
        interestRate,
        values["repaymentFrequency"]
      );
      setFieldValue(fields.periodicPayment, newPeriodicPayment);
    }

    //Case 10
    // if (value && !values.requestedAmount && values[fields.periodicPayment]) {
    //   const newLoanRequestAmount = getLoanRequestAmount(
    //     values[fields.periodicPayment],
    //     newYears,
    //     newMonths
    //   );
    //   setFieldValue(fields.requestedAmount, newLoanRequestAmount);
    // }
  };

  const handleTenureChangeFor = (Month, Year) => {
    const newMonths = Month;
    const newYears = Year;
    //Case 4,5

    if (values.requestedAmount) {
      const newPeriodicPayment = getPeriodicPayment(
        values.requestedAmount,
        newYears,
        newMonths,
        interestRate,
        values["repaymentFrequency"]
      );
      return newPeriodicPayment;
    }
  };
  // const onFrequencyTypeChange = (value) => {
  //   const updatedValues = clearFieldValues({
  //     values,
  //     fieldsToExculde: [fields.frequencyType],
  //   });}
  function getTenure(loanAmount, periodicPayment) {
    const effectiveInterest = getInterestRateForFrequency(
      interestRate,
      values["repaymentFrequency"]
    );

    let num =
      periodicPayment / (periodicPayment - effectiveInterest * loanAmount);
    let denom = 1 + effectiveInterest;
    let lognum = Math.log10(num);
    let logdenom = Math.log10(denom);
    return (
      Math.log10(
        periodicPayment / (periodicPayment - effectiveInterest * loanAmount)
      ) / Math.log10(1 + effectiveInterest)
    );
    // return Math.floor(Math.random() * 1) + 1;
  }

  function getLoanRequestAmount(periodicPayment, noOfYears, noOfMonths) {
    const totalNumberOfInstallments = calculateTotalNoOfInstallments(
      values["repaymentFrequency"],
      noOfYears,
      noOfMonths
    );
    const rateOfInterestPerInstallment =
      interestRate / totalNumberOfInstallments;

    return Math.round(
      (periodicPayment *
        (1 -
          Math.pow(
            1 + rateOfInterestPerInstallment,
            -totalNumberOfInstallments
          ))) /
        rateOfInterestPerInstallment,
      10
    );
    // return Math.floor(Math.random() * 100) + 1;
  }

  const onDaySelected = (fieldName, value) => {
    setFieldValue(fieldName, value);
  };

  const minDate = moment(new Date())
    .add(
      data?.processingTimeForLoan + data?.firstRepaymentDateFallsAfter,
      "days"
    )
    .format("MM/DD/YYYY");

  const maxDate = moment(new Date())
    .add(
      data?.processingTimeForLoan + data?.firstRepaymentDateFallsWithin,
      "days"
    )
    .format("MM/DD/YYYY");

  const applicablePaymentMethods = get(data, "applicablePaymentMethods", []);
  const [paydates, setPaydates] = useState([]);

  useEffect(() => {
    [2, 3].includes(values[fields.repaymentMethod])
      ? setPaydates(payrollSchedule?.find((_) => _.id == empFreqId))
      : setPaydates([]);
  }, [values[fields.repaymentMethod]]);

  var payDatesOptions = paydates?.payrollSchedules?.map((itm, i) => {
    return (itm = {
      label: momentDateFormat(itm.payDate),
      value: itm.payDate,
    });
  });
  payDatesOptions = payDatesOptions?.filter(
    (itm) =>
      new Date(itm.label) >= new Date(minDate) &&
      new Date(itm.label) <= new Date(maxDate)
  );

  return (
    <div
      className="withdrawal-card"
      style={{
        width: "100%",
        marginBottom: "20px",
        border: "0.5px solid #BDBDBD",
        borderRadius: "5px",
        padding: "0px",
      }}
    >
      <div
        className="withdrawalCard-header"
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          borderBottom: " 0.5px solid #BDBDBD",
          padding: "15px",
        }}
      >
        <div style={{ display: "flex", flexDirection: "row" }}>
          <FontAwesomeIcon
            style={{
              fontWeight: "300",
              fontSize: "14px",
              color: "#333333",
              marginRight: "5px",
              marginTop: "3px",
            }}
            icon={faExclamationCircle}
          />
          <p
            style={{
              fontWeight: "400",
              fontSize: "14px",
              color: "#333333",
              margin: "0px",
              padding: "0px",
            }}
          >
            Calculate repayment by entering any two values Loan request amount,
            Periodic payment, Tenure period.
          </p>
        </div>
      </div>
      <div style={{ display: "flex", flexDirection: "row" }}>
        <div
          style={{
            width: "50%",
            paddingLeft: "25px",
          }}
        >
          <p
            style={{
              fontWeight: "500",
              fontSize: "14px",
              color: "#333333",
              marginBottom: "10px",
              marginTop: "30px",
            }}
          >
            Interest Rate
          </p>
          <p
            style={{
              fontWeight: "500",
              fontSize: "14px",
              color: "#333333",
            }}
          >
            {interestRate}%
          </p>
          {/* <Field
            size="sm"
            isRequired
            style={{ marginBottom: "0px" }}
            //   className="w-200 marg-right-20"
            name={[fields.interestRate]}
            type="text"
            autoComplete="off"
            value={values[fields.interestRate]}
            onChange={(e) => {
              handleChange(e);
            }}
            disabled={!values[fields.allowParticipantsToChooseInterestRate]}
            component={FieldInputPercentage}
          /> */}
          {/* <p
            style={{
              fontWeight: "500",
              fontSize: "14px",
              color: "#333333",
              marginBottom: "10px",
              marginTop: "30px",
            }}
          >
            Take entire loan amount
          </p> */}
          <Field
            isRequired
            name={fields.withdrawEntire}
            label="Take entire loan amount"
            size="sm"
            options={yesNoOptions}
            selectedValue={returnOnlyIfBoolean(values[fields.withdrawEntire])}
            onChange={(value) => {
              setFieldValue(fields.withdrawEntire, value);
              setFieldValue(
                fields.requestedAmount,
                value ? availableBalanceForLoan : ""
              );
            }}
            component={FieldButtonGroup}
          />
          {/* <p
            style={{
              fontWeight: "500",
              fontSize: "14px",
              color: "#333333",
              marginBottom: "10px",
              marginTop: "30px",
            }}
          >
            Loan request amount
          </p> */}
          <Field
            size="sm"
            isRequired
            style={{ marginBottom: "0px" }}
            //   className="w-200 marg-right-20"
            name={fields.requestedAmount}
            label="Loan request amount"
            type="text"
            autoComplete="off"
            max={50000.0}
            min={0}
            value={get(values, fields.requestedAmount)}
            onChange={(e) => {
              handleLoanRequestAmountChange(e.target.value);
              handleChange(e);
            }}
            component={FieldInputDollarBox}
            disabled={values[fields.withdrawEntire]}
            validate={(val) =>
              ![null, undefined, ""].includes(val) &&
              (val < data.minimumAmount || val > availableBalanceForLoan)
                ? `LO004 : You may request a min. of ${data.minimumAmount} to a max. of ${availableBalanceForLoan}`
                : undefined
            }
          />
          <div style={{ display: "flex", flexDirection: "row" }}>
            <FontAwesomeIcon
              style={{
                fontWeight: "300",
                fontSize: "14px",
                color: "#333333",
                marginRight: "5px",
              }}
              icon={faExclamationCircle}
            />
            <p style={{ fontWeight: "400", fontSize: "12px" }}>
              You can make request from
              <span style={{ fontWeight: "500" }}>
                ${data.minimumAmount}
              </span>{" "}
              to{" "}
              <span style={{ fontWeight: "500" }}>
                ${availableBalanceForLoan?.toFixed(2)}
              </span>
            </p>
          </div>

          <Field
            isRequired
            name={fields.repaymentMethod}
            size="lg"
            label="Repayment Method"
            options={repaymentMethodsOptions}
            selectedValue={values[fields.repaymentMethod]}
            onChange={(value) => {
              setValues({
                ...values,
                ...{
                  [fields.repaymentBankDetail]: [1, 3].includes(value)
                    ? get(apiData, "bankInformationDetails.0", {})
                    : null,
                  [fields.repaymentFrequency]: [2, 3].includes(value)
                    ? get(
                        frequencyListData.filter((_) => _.id == empFreqId),
                        "[0].frequencyTypeString",
                        null
                      )
                    : null,
                  [fields.repaymentMethod]: value,
                  [fields.firstRepaymentDate]:
                    payDatesOptions?.length == 1
                      ? get(payDatesOptions, "[0].value", null)
                      : null,
                },
              });
              setPaydates(
                payrollSchedule?.filter((_) => _.frequencyId == empFreqId)
              );
            }}
            value={values[fields.repaymentMethod]}
            disabled={applicablePaymentMethods.length == 1}
            component={FieldButtonGroup}
          />
          {/* <Field
            isRequired
            size="lg"
            name={fields.repaymentMethod}
            options={repaymentMethodsOptions}
            selectedValue={values[fields.repaymentMethod]}
            disabled={applicablePaymentMethods.length == 1}
            value={values[fields.repaymentMethod]}
            onChange={(value) => {
              setValues({
                ...values,
                ...{
                  [fields.repaymentBankDetail]:
                    value.includes(1) || values.length > 1
                      ? get(apiData, "bankInformationDetails.0", {})
                      : null,
                  [fields.repaymentFrequency]: value.includes(2)
                    ? get(
                        frequencyListData.filter((_) => _.id == empFreqId),
                        "[0].id",
                        null
                      )
                    : null,
                  [fields.repaymentMethod]: value,
                  [fields.firstRepaymentDate]: null,
                },
              });
            }}
            component={FieldMultiSelectButtonGroup}
          /> */}
          {/* <p
            style={{
              fontWeight: "500",
              fontSize: "14px",
              color: "#333333",
              marginBottom: "10px",
              marginTop: "15px",
            }}
          >
            Repayment frequency
          </p> */}

          {[2, 3].includes(values?.repaymentMethod) ? (
            <>
              <div className="ft-12 mt-4 mb-2">Repayment frequency</div>
              <div className="ft-14 fw-500 mt-0 mb-3">
                {
                  frequencyListData?.filter((_) => _.id == empFreqId)[0]
                    ?.frequencyTypeString
                }
              </div>
            </>
          ) : (
            <>
              <Field
                label="Repayment Frequency"
                name={fields.repaymentFrequency}
                placeholder="Select frequency"
                isRequired
                size={"smd"}
                value={values[fields.repaymentFrequency]}
                options={payrollFrequency.data.filter(
                  (_, index) => _.value !== 3
                )}
                popupContent={
                  <SearchableList
                    label="Select a repayment frequency"
                    options={payrollFrequency.data.filter(
                      (_, index) => _.value !== 3
                    )}
                    onSelect={(value, label) => {
                      setFieldValue(
                        fields.repaymentFrequency,
                        label.replace("-", "")
                      );
                      setPaydates(
                        payrollSchedule.filter((_) => _.frequencyId == value)
                      );
                      setFieldValue(fields.firstRepaymentDate, null);
                    }}
                    selectedValue={values[fields.repaymentFrequency]}
                    name={fields.repaymentFrequency}
                    isNotTypeAhead
                    isRadio
                  />
                }
                component={FieldDropSide}
              />
            </>
          )}
          <Field
            size="sm"
            isRequired
            //   style={{ width: "20px" }}
            label="Periodic payment"
            value={values[fields.periodicPayment]}
            //   className="w-200 marg-right-20"
            name={fields.periodicPayment}
            type="text"
            autoComplete="off"
            max={50000.0}
            min={0}
            // onChange={handlePeriodicPaymentChange}
            onChange={(e) => {
              handlePeriodicPaymentChange(e.target.value);
              handleChange(e);
            }}
            component={FieldInputDollarBox}
          />
          {values[fields.requestedAmount] > 0 ? (
            <div style={{ display: "flex", flexDirection: "row" }}>
              <FontAwesomeIcon
                style={{
                  fontWeight: "300",
                  fontSize: "14px",
                  color: "#333333",
                  marginRight: "5px",
                }}
                icon={faExclamationCircle}
              />
              <p style={{ fontWeight: "400", fontSize: "12px" }}>
                Periodic Payment should be greater than or equal to $
                {handleTenureChangeFor(
                  data.maximumLengthMonths,
                  data.maximumLengthYears
                )}
              </p>
            </div>
          ) : null}
          {/* <div style={{ display: "flex", flexDirection: "row" }}>
            <FontAwesomeIcon
              style={{
                fontWeight: "300",
                fontSize: "14px",
                color: "#333333",
                marginRight: "5px",
              }}
              icon={faExclamationCircle}
            />
            <p style={{ fontWeight: "400", fontSize: "12px" }}>
              Repayment term -
              <span style={{ fontWeight: "500" }}>
                {
                  frequencyOptions.find(
                    (_, index) => _.value == values[fields.frequencyType]
                  )?.label
                }
              </span>
            </p>
          </div> */}
          <p
            style={{
              fontSize: "12px",
              color: "#333333",
              marginBottom: "10px",
              marginTop: "15px",
            }}
          >
            Tenure period
          </p>
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div>
              <Field
                size="xs"
                isRequired
                //   style={{ width: "20px" }}
                //   className="w-200 marg-right-20"
                name={fields.tenureYears}
                type="number"
                autoComplete="off"
                value={values[fields.tenureYears]}
                max={values["loanType"] == 2 ? 30 : 5}
                min={0}
                onChange={(e) => {
                  handleTenureChange(false, e.target.value);
                  handleChange(e);
                }}
                component={FieldInputNumber}
              />
            </div>

            <div
              className={`input-dollar-box ${"disabled"}`}
              style={{ borderLeft: "0px", marginTop: "7px" }}
            >
              Years
            </div>

            <div style={{ marginLeft: "10px" }}>
              <Field
                size="xs"
                isRequired
                name={fields.tenureMonths}
                max={
                  values["loanType"] == 2 && values["tenureYears"] == 30
                    ? 0
                    : values["loanType"] == 1 && values["tenureYears"] == 5
                    ? 0
                    : 11
                }
                min={0}
                type="number"
                autoComplete="off"
                value={values[fields.tenureMonths]}
                onChange={(e) => {
                  handleTenureChange(true, e.target.value);
                  handleChange(e);
                }}
                component={FieldInputNumber}
              />
            </div>

            <div
              className={`input-dollar-box ${"disabled"}`}
              style={{ borderLeft: "0px", marginTop: "7px" }}
            >
              Months
            </div>
          </div>
          <div style={{ display: "flex", flexDirection: "row" }}>
            <FontAwesomeIcon
              style={{
                fontWeight: "300",
                fontSize: "14px",
                color: "#333333",
                marginRight: "5px",
              }}
              icon={faExclamationCircle}
            />
            <p style={{ fontWeight: "400", fontSize: "12px" }}>
              Max tenure is {data.maximumLengthYears} years{" "}
              {data.maximumLengthMonths} months
            </p>
          </div>
          {
            // values?.repaymentMethod == 1 ||
            values?.repaymentMethod != undefined ? (
              <Field
                isRequired
                size="smd"
                label="First Repayment Date"
                name={fields.firstRepaymentDate}
                value={usDateFormat(values[fields.firstRepaymentDate])}
                isDatePicker
                onClear={() => onDaySelected(fields.firstRepaymentDate, null)}
                popupContent={
                  <DatePicker
                    // minDate={new Date(minDate)}
                    // maxDate={new Date(maxDate)}
                    onDayClick={(value) =>
                      onDaySelected(fields.firstRepaymentDate, value)
                    }
                    value={usDateFormat(values[fields.firstRepaymentDate])}
                  />
                }
                component={FieldDropSide}
              />
            ) : (
              <Field
                name={fields.firstRepaymentDate}
                label={"First Repayment Date"}
                isRequired
                value={
                  (values[fields.firstRepaymentDate] =
                    payDatesOptions?.length == 1
                      ? get(payDatesOptions, "[0].value", null)
                      : values[fields.firstRepaymentDate])
                }
                disabled={payDatesOptions?.length == 1}
                options={payDatesOptions}
                size={"smd"}
                popupContent={
                  <SearchableList
                    label="Select a first repayment date"
                    options={payDatesOptions}
                    onSelect={(value) => {
                      setFieldValue(fields.firstRepaymentDate, value);
                    }}
                    selectedValue={values[fields.firstRepaymentDate]}
                    name={fields.firstRepaymentDate}
                    isNotTypeAhead
                    isRadio
                  />
                }
                component={FieldDropSide}
              />
            )
          }
        </div>
        {![null, undefined, "", 0].includes(values.requestedAmount) &&
          (values.tenureMonths || values.tenureYears) > 0 &&
          values[fields.periodicPayment] &&
          !isNull(values[fields.firstRepaymentDate]) && (
            <div
              style={{
                width: "50%",
                borderLeft: "0.5px solid #BDBDBD",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  width: "100%",
                  paddingTop: "150px",
                }}
              >
                <p
                  style={{
                    fontWeight: "500",
                    fontSize: "18px",
                    color: "#000000",
                    margin: "0px",
                  }}
                >
                  $
                  {values[fields.periodicPayment]
                    ? values[fields.periodicPayment].toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                      })
                    : "-"}
                </p>
                <p
                  style={{
                    fontWeight: "400",
                    fontSize: "14px",
                    color: "#777777",
                    padding: "0px",
                    marginBottom: "40px",
                  }}
                >
                  your
                  <span style={{ fontWeight: "500", paddingLeft: "3px" }}>
                    {
                      frequencyListData.find((_, index) => _.id == empFreqId)
                        ?.frequencyTypeString
                    }
                  </span>{" "}
                  loan payment
                </p>
                {values[fields.firstRepaymentDate] != null && (
                  <>
                    <p
                      style={{
                        fontWeight: "500",
                        fontSize: "18px",
                        color: "#000000",
                        margin: "0px",
                      }}
                    >
                      {momentDateFormat(
                        get(values, fields.firstRepaymentDate, null)
                      )}
                    </p>
                    <p
                      style={{
                        fontWeight: "400",
                        fontSize: "14px",
                        color: "#777777",
                        padding: "0px",
                        marginBottom: "40px",
                      }}
                    >
                      First repayment date
                    </p>
                  </>
                )}
                <div
                  onClick={() => {
                    setSliderOpen4(true);
                  }}
                >
                  <p
                    style={{
                      fontWeight: "500",
                      fontSize: "16px",
                      color: "#307BF6",
                    }}
                  >
                    View Amortization Schedule
                  </p>
                </div>
              </div>
            </div>
          )}
      </div>
    </div>
  );
};

export default LoanCard;
